'use es6';

import { createRequestTypes, createRequestActions } from './RequestActions';
import makeFetchRequest from './makeFetchRequest';
import { getIsRetail } from '../api/RetailApi';
export const FetchRetailRequestTypes = createRequestTypes('RETAIL');
export const FetchRetailActions = createRequestActions(FetchRetailRequestTypes);
export const fetchIsRetail = () => dispatch => {
  return makeFetchRequest({
    requestActions: FetchRetailActions,
    fetch: getIsRetail
  })(dispatch);
};